import MobileVerification from './MobileVerification';

export default MobileVerification;
